import apiFetch from '../apiFetch'

export default function (token, faqSectionId) {
  return apiFetch({ endPoint: `FaqSection/Recover/${faqSectionId}`, method: 'PUT', token: token })
}
